const TMenuItem = {
    // English
    "enUS": {
        'NEW_MENU': 'New Menu',
        'MENU_NAME': 'Menu Name',
        'ADD_MENU': 'Add Menu',
        'EDIT': 'Edit',
        'ENABLED': 'Enabled',
        'DISABLED': 'Disabled',
        'SAVE': 'Save',
        'CANCEL': 'Cancel',
        'QR_CODE': 'QR Code',
        'DOWNLOAD': 'Download',
        'IMPORT': 'Import',
        'IMPORT_MENU': 'Import Menu',
        'IMPORT_MENU_TEXT': 'Import your menu from a PDF or an image? It will overwrite the existing menu.',
    },
    // Spanish
    "esMX": {
        'NEW_MENU': 'Nuevo Menú',
        'MENU_NAME': 'Nombre del Menú',
        'ADD_MENU': 'Agregar Menú',
        'EDIT': 'Editar',
        'ENABLED': 'Activo',
        'DISABLED': 'Inactivo',
        'SAVE': 'Guardar',
        'CANCEL': 'Cancelar',
        'QR_CODE': 'Código QR',
        'DOWNLOAD': 'Descargar',
        'IMPORT': 'Importar',
        'IMPORT_MENU': 'Importar Menú',
        'IMPORT_MENU_TEXT': 'Importar tu menú desde un archivo PDF o una imagen? Se sobreescribirá el menú existente.',
    }
}
export default TMenuItem;